import styled from 'styled-components';

export const Header = styled.header`
  font-family: 'Roboto Bold', sans-serif;
  @media only screen and (max-width: 900px) {
  // width: 100vh;
    h1 {
      margin: 10px;
      font-size: 20px;
      z-index: -2;
      align-items: center;
      display:flex;
      }
    }

  display: flex;
  width: 100%;
  position: fixed;
  z-index: 3;
  align-items: center;
  // gap: 40rem;
  justify-content: space-around;
  // padding:  3vh;
  background-color: ${({ theme }) => theme.background1};
  height: 80px;
  h1 {
    color: ${({ theme }) => theme.font1};
  }
  h1: hover {
    color: ${({ theme }) => theme.font2}};
  }
  border-bottom: 1px solid ${({ theme }) =>
    theme.font2}; /* Altera a cor da margem esquerda */
`;

// export const Nav = styled.div<{ open: boolean }>`
//   display: flex;
//   gap: 1rem;
//   button {
//     border: none;
//     background-color: transparent;
//   }
//   justify-content: center;
//   a {
//     color: ${({ theme }) => theme.font1};
//     display: flex;
//     align-items: center;
//   }
//   nav {
//     display: flex;
//     gap: 1rem;
//     align-content: center;
//     align-items: center;
//   }
//   a: hover {
//     color: ${({ theme }) => theme.font3};
//   }

//   @media only screen and (min-width: 900px) {
//     .container {
//       display: none;
//     }
//   }

//   .bar1,
//   .bar2,
//   .bar3 {
//     width: 25px;
//     height: 2px;
//     background-color: ${({ theme }) => theme.font2};
//     margin: 2px 0;
//     transition: 0.4s;
//   }

//   .change .bar1 {
//     transform: translate(0, 5px) rotate(-45deg);
//   }

//   .change .bar2 {
//     opacity: 0;
//   }

//   .change .bar3 {
//     transform: translate(0, -3px) rotate(45deg);
//   }
//   @media only screen and (max-width: 900px) {
//     display: flex;
//     align-items: center;

//     .container: {
//       position: absolute;
//       display: inline-block;
//       cursor: pointer;
//       z-index: 2;
//     }

//     nav {
//       align-content: center;
//       align-items: center;
//       transform: ${({ open }) => (open ? `translateX(0)` : `translateX(100%)`)};
//       background-color: ${({ theme }) => theme.font1};
//       flex-direction: column;
//       justify-content: center;
//       gap: 2rem;
//       width: 50%;
//       height: 100vh;
//       position: fixed;
//       z-index: -1;
//       top: 0;
//       right: 0;
//     }
//   }
// `;

export const Nav = styled.div<{ open: boolean }>`
  display: flex;
  gap: 1rem;
  button {
    border: none;
    background-color: transparent;
  }
  justify-content: space-between;
  a {
    color: ${({ theme }) => theme.font1};
    display: flex;
    align-items: center;
    position: relative;
    text-decoration: none;

    &::after {
      content: '';
      position: absolute;
      width: 0;
      height: 1px;
      bottom: -3px;
      left: 0;
      background-color: ${({ theme }) => theme.font3};
      transition: width 0.3s ease-in-out;
    }

    &:hover::after {
      width: 100%;
    }
  }
  a: hover {
    color: ${({ theme }) => theme.font3};
  }

  nav {
    display: flex;
    gap: 1rem;
    align-content: center;
    align-items: center;
  }

  @media only screen and (min-width: 900px) {
    .container {
      display: none;
    }
  }
  .bar1,
  .bar2,
  .bar3 {
    width: 40px;
    height: 5px;
    background-color: ${({ theme }) => theme.font3};
    margin: 5px 0;
    transition: transform 0.4s, opacity 0.4s;
  }

  .change .bar1 {
    transform: translateY(12px) rotate(-45deg);
  }

  .change .bar2 {
    opacity: 0;
  }

  .change .bar3 {
    transform: translateY(-8.5px) rotate(45deg);
  }

  @media only screen and (max-width: 900px) {
    display: flex;
    align-items: center;

    .container {
      position: absolute;
      display: inline-block;
      cursor: pointer;
      z-index: 2;
    }

    nav {
      align-content: center;
      align-items: center;
      transform: ${({ open }) => (open ? `translateX(0)` : `translateX(100%)`)};
      background-color: ${({ theme }) => theme.font4};
      flex-direction: column;
      justify-content: center;
      gap: 2rem;
      width: 50%;
      height: 100vh;
      position: fixed;
      z-index: -1;
      top: 0;
      right: 0;
    }
  }
`;

export const Switch = styled.div`
    cursor: pointer;
    position: relative;
    display: inline-block;
    width: 51px;
    height: 24px;
    background-color:  ${({ theme }) => theme.font3};
    border-radius: 34px;
    background-image: url(${({ theme }) => theme.moon});
    background-position: ${({ theme }) =>
      theme.theme === 'light' ? 'left' : 'right'};
    background-repeat: no-repeat;
    background-size: 25px 25px;
  }
`;

export const Logo = styled.div`
  // position: relative;
  // display: inline-block;
  // top: 0
  align-items: center;
  display: flex;
  width: 25vh;
  height: 10vh;

  background-image: url(${({ theme }) => theme.logoblack});
  background-repeat: no-repeat;
  background-size: 150px;
  background-position: center;
`;
